import Vue from 'vue';
import ApolloClient from 'apollo-boost';
import VueApollo from 'vue-apollo';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { API_URL } from './strapi';

Vue.use(VueApollo);

const uri = API_URL + '/graphql';

const client = new ApolloClient({
  uri,
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network', // default fetch policy
      amountLimit: 5, // limit the number of documents fetched from the cache
    },
    query: {
      fetchPolicy: 'cache-first', // default fetch policy
      amountLimit: 5, // limit the number of documents fetched from the cache
    },
    mutate: {
      amountLimit: 5, // limit the number of documents fetched from the cache
    },
  },
});

const provider = new VueApollo({
  defaultClient: client,
});

export default provider;
